import {
  init as SentryInit,
  browserTracingIntegration,
  replayIntegration,
} from '@sentry/vue';

import setupRouter from '@/router';
import { setupI18n } from '@/locales/i18n';

import MainApp from './App.vue';

if (import.meta.env.DEV) {
  import('@/assets/scss/index.scss');
}

(async () => {
  const pinia = createPinia();
  const app = createApp(MainApp);

  const router = await setupRouter(app);

  await setupI18n({
    vueApp: app,
    pageName: router.currentRoute.value.meta.i18nAlias as string,
    router,
  });

  if (import.meta.env.VITE_SENTRY_DSN) {
    SentryInit({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [
        browserTracingIntegration({ router }),
        replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: ['URI malformed'],
    });
  }

  app.use(pinia);
  app.mount('#app');
})();
